import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../i18n/I18nUtils';
import _ from 'lodash';
import { connect } from 'react-redux';
import { PsTable } from '../../shared/components/table/PsTable';
import ActiveLabel from '../../shared/components/ActiveLabel';
import DocumentSchemas from '../../shared/components/DocumentSchemas';
import RouterUtils from '../../shared/routing/RouterUtils';
import { CurrentUser } from '../../shared/model/CurrentUser';
import DocumentState from '../../shared/components/DocumentState';
import { PsMoreMenu } from '../../shared/components/more-menu/PsMoreMenu';
import { PsRoutes } from '../../shared/routing/Routes';
import WorkerState from '../../shared/model/WorkerState';

class WorkersTable extends React.Component {

    render() {
        const {
            data,
            error,
            currentUser,
            companyColumn,
        } = this.props;

        if ( !currentUser.hasRole() ) return null;

        if ( error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{error}</h3>
                </section>
            );
        }

        if ( !data || data.length === 0 ) return null;

        const companyTR = companyColumn === 'outsource' ? 'TR_SUBCONTRATA' : 'TR_CONTRATISTA';

        return (
            <PsTable
                headings={(
                    <tr>
                        <th>{I18nUtils.tr('TR_ESTADO')}</th>
                        <th>{I18nUtils.tr('TR_ESTADO_DOCUMENTACION')}</th>
                        <th>{I18nUtils.tr('TR_DNI_NIF')}</th>
                        <th>{I18nUtils.tr('TR_NOMBRE')}</th>
                        <th>{I18nUtils.tr('TR_APELLIDO_S')}</th>
                        <th>{I18nUtils.tr(companyTR)}</th>
                        <th>{I18nUtils.tr('TR_OFICIO')}</th>
                        <th>{I18nUtils.tr('TR_ESQUEMA')}</th>
                        <th />
                    </tr>
                )}
            >
                {
                    _.map(data, (worker) => {
                        const {
                            id,
                            worker_state,
                            dni,
                            name,
                            last_name,
                            company,
                            position,
                            document_schema,
                            contractors,
                            contractor,
                            worker_documentation_state,
                            worker_contractor_state,
                        } = worker;

                        const companyName = companyColumn === 'outsource'
                            ? ( company ? company.name : '')
                            : ( contractor ? contractor.name : '');

                        const options = [
                            {
                                route: RouterUtils.generateRoute(
                                    PsRoutes.MY_OUTSOURCES_WORKERS_DETAIL,
                                    { outsourceId: company.id, workerId: id },
                                ),
                                label: !currentUser.isOutsourcesViewer()
                                    ? I18nUtils.tr('TR_EDITAR')
                                    : I18nUtils.tr('TR_VER_FICHA'),
                            },
                        ];

                        const workerState = worker_contractor_state ? worker_contractor_state : worker_state;

                        return (
                            <tr>
                                <td><ActiveLabel state={workerState} /></td>
                                <td><DocumentState state={worker_documentation_state}/></td>
                                <td>{dni}</td>
                                <td><strong>{name}</strong></td>
                                <td><strong>{last_name}</strong></td>
                                <td>{companyName}</td>
                                <td>{position || ''}</td>
                                <td>
                                    <DocumentSchemas
                                        currentUser={currentUser}
                                        contractors={contractors}
                                        documentSchema={document_schema}
                                        isOutsource={companyColumn === 'outsource'}
                                    />
                                </td>
                                <td><PsMoreMenu options={options}/></td>
                            </tr>
                        );
                    })
                }
            </PsTable>
        );
    }

}

const mapStateToProps = state => {
    return ( {
        currentUser: CurrentUser.fromReduxState(state),
    } );
};

export default connect(mapStateToProps)(WorkersTable);

WorkersTable.propTypes = {
    data: PropTypes.any,
    error: PropTypes.string,
    companyColumn: PropTypes.oneOf('contractor', 'outsource'),
};

WorkersTable.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/worker/components/WorkersTable.jsx